import React, { useState } from 'react'
import SelectInvoicesModal from './SelectInvoicesModal'
import { PaperClipOutlined } from '@ant-design/icons'
import { Button } from 'antd'

const SelectFromOMS = ({
  setSelectedInvoices,
  onInvoicesConfirmed,
  defaultSupplierTitle,
}) => {
  const [isOMSModalOpen, setIsOMSModalOpen] = useState(false)

  return (
    <div
      style={{
        flex: 1,
        minWidth: 220,
        border: '1px solid #f0f0f0',
        borderRadius: 8,
        padding: 24,
        textAlign: 'center',
      }}
    >
      <div style={{ marginBottom: 16 }}>
        <div
          style={{
            fontSize: 32,
            color: '#52c41a',
          }}
        >
          <PaperClipOutlined />
        </div>
      </div>
      <h3>Choose from OMS Storage</h3>
      <p>Select from previously uploaded invoices</p>
      <Button
        onClick={() => {
          setIsOMSModalOpen(true)
        }}
      >
        Browse Invoices
      </Button>
      <SelectInvoicesModal
        isOMSModalOpen={isOMSModalOpen}
        setIsOMSModalOpen={setIsOMSModalOpen}
        setSelectedInvoices={setSelectedInvoices}
        onInvoicesConfirmed={onInvoicesConfirmed}
        defaultSupplierTitle={defaultSupplierTitle}
      />
    </div>
  )
}

export default SelectFromOMS
